import React, { useState } from 'react';
import { eleveSchema } from '../../../../types/user/eleve.def';
import { useMutation, useQuery } from '@apollo/client';
import { ADD_ELEVE } from '../../../../graphql/mutation/user/eleve/eleve';
import { addEleveParams } from '../../../../helpers/user/addEleveParams';
import { EleveFields } from './EleveFields';
import { createUserMutationOptions } from '../../../../graphql/mutation/user/eleve/createUserMutationOptions';
import { QueryUserClasseQuery } from '../../../../graphql/generated/graphql';
import { QUERY_USER_CLASSE } from '../../../../graphql/query/user/queryUserAccount';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';

const FormCreateEleve = () => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const { data, loading: load, error } = useQuery<QueryUserClasseQuery>(
    QUERY_USER_CLASSE
  );
  const maClasse = data?.getUserClasse.id;
  const [eleveForm, setEleveForm] = useState({
    ...eleveSchema
  });
  const [createUser] = useMutation(
    ADD_ELEVE,
    createUserMutationOptions({ setForm: setEleveForm })
  );

  const submit = async () => {
    setSubmitLoading(true);
    if (eleveForm.isValid) {
      await createUser({
        variables: addEleveParams(eleveForm.values, maClasse)
      });
      setSubmitLoading(false);
    }
    setSubmitLoading(false);
  };

  if (load) return <LoadingContainer />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError('Erreur dans la récupération de la classe.')
        }
      />
    );

  return (
    <>
      <EleveFields eleveForm={eleveForm} setEleveForm={setEleveForm} />
      <div style={{ margin: 'auto' }}>
        <ButtonWithText
          content={'Ajouter à la classe'}
          onClick={submit}
          icon={'Plus'}
          disabled={!eleveForm.isValid}
          loading={submitLoading}
        />
      </div>
    </>
  );
};

export default FormCreateEleve;
